<template>
  <section class="hero">
    <div class="hero__content">
      <p class="hero__eyebrow">IPA Tournament Hub</p>
      <h1>Create and Manage Football Tournaments Easily</h1>
      <p class="hero__subtext">
        Fixtures, standings, payments, and teams - all in one place.
      </p>
      <div class="hero__actions">
        <router-link class="hero__cta" to="/ipromiseafrica/tournament/register">
          Create Tournament
        </router-link>
        <router-link class="hero__cta hero__cta--secondary" to="/ipromiseafrica/tournament/fanbase">
          Browse fanbase
        </router-link>
        <router-link class="hero__cta hero__cta--secondary" to="/ipromiseafrica/tournament/dashboard">
          Manage Tournaments
        </router-link>
      </div>
    </div>

    <div class="hero__images">
      <img :src="footballImage" alt="Tournament football action" loading="lazy" />
      <img :src="footballImageAlt" alt="Football team preparing for tournament" loading="lazy" />
    </div>
  </section>
</template>

<script setup>
import footballImage from "@/assets/images/tournament/football.jpg";
import footballImageAlt from "@/assets/images/tournament/football1.jpg";
</script>

<style scoped>
.hero {
  display: grid;
  gap: 1.25rem;
  grid-template-columns: 1fr;
  padding: 1rem 0 0.5rem;
}

.hero__eyebrow {
  font-weight: 700;
  text-transform: uppercase;
  color: var(--border-color-hover);
  margin-bottom: 0.75rem;
  letter-spacing: 0.14em;
  font-size: 0.75rem;
}

h1 {
  margin: 0;
  font-size: clamp(1.9rem, 4.3vw, 3rem);
  line-height: 1.15;
  color: var(--text-color1);
  font-weight: 800;
}

.hero__subtext {
  margin: 1rem 0 1.25rem;
  color: var(--text-color1);
  font-size: 1.03rem;
  max-width: 52ch;
  opacity: 0.9;
}

.hero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.hero__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 30px;
  background: var(--border-color-hover);
  color: var(--text-color3);
  text-decoration: none;
  border-radius: 32px;
  font-weight: 600;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
  transition: 0.3s ease;
}

.hero__cta--secondary {
  background: transparent;
  color: var(--text-color1);
  border: 1px solid var(--border-color-hover);
  box-shadow: none;
}

.hero__cta:hover {
  transform: translateY(-3px);
  box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.35);
}

.hero__cta--secondary:hover {
  background: color-mix(in srgb, var(--border-color-hover) 12%, transparent);
}

.hero__images {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
}

.hero__images img {
  width: 100%;
  border-radius: 18px;
  object-fit: cover;
  min-height: 210px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.06);
}

@media (min-width: 960px) {
  .hero {
    grid-template-columns: 1fr 1.2fr;
    align-items: center;
    gap: 2.4rem;
  }

  .hero__images {
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }
}
</style>
